import { InnerQueryExpression } from "../InnerQueryExpression";

export class InstanceIdCallExpression implements InnerQueryExpression {
    public readonly $discriminator = "InstanceIdCall";
}
